import React, { ReactNode } from 'react';
import {
  Box,
  Spinner,
  ThemeProvider,
  ToastProvider,
  getTheme,
  thc,
} from '@flightstats/airframe-react';
import cn from 'classnames';
import styles from './airframe.overrides.module.css';

interface ContentWrapperProps {
  className?: string;
}
const ContentWrapper = thc<ContentWrapperProps>(Box, {
  padding: {
    xs: '0 10px',
  },
});

interface Props {
  header?: ReactNode;
  loading?: boolean;
  children: ReactNode;
}

const CiriumWrapperWithoutGlobalStyles: React.FC<Props> = ({
  header,
  loading,
  children,
}) => (
  <ThemeProvider theme={getTheme()}>
    <>
      <ToastProvider>
        {header}
        {loading && <Spinner modal />}
        <ContentWrapper className={cn(styles.airframe, styles.overrides)}>
          {children}
        </ContentWrapper>
      </ToastProvider>
    </>
  </ThemeProvider>
);

export default CiriumWrapperWithoutGlobalStyles;